module.exports = __webpack_public_path__ + "img/music_placeholder.917378d4.png";